import React, { useEffect, useState } from 'react';
import { Input, Button, Row, Col, Typography, Divider } from 'antd';
import { STATUS } from '../../../../redux/constants';
import styles from './account.module.sass';
import {
  CloseCircleOutlined,
  EditOutlined,
  StopOutlined,
} from '@ant-design/icons';
import TwoFAModal from '../TwoFAModal';
import EditPasswordModal from '../EditPasswordModal';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import VersionCheck from '../../../../shared-components/VersionCheck';
import cx from 'classnames';
import Panel from '../../../../shared-components/Panel';
import EmptyLoadingState from '../../../../shared-components/EmptyLoadingState';
import { formatEmail } from '../../../../redux/utils/email';

function AccountSettings(props) {
  const { Title, Paragraph } = Typography;
  const { status, is2faEnabled } = props;
  const [userData, setUserData] = useState({});
  const [show2FAModal, set2FAModal] = useState(false);
  const [showEditPasswordModal, setShowEditPasswordModal] = useState(false);
  const dispatch = useDispatch();
  dispatch(changeTitle('Account Settings', null));

  function handleChange(e, name) {
    setUserData({
      ...userData,
      [name]: formatEmail(e.target.value),
    });
  }

  function open2FAModal() {
    set2FAModal(true);
  }

  function openEditPasswordModal() {
    setShowEditPasswordModal(true);
  }

  function save() {
    props.updateUserProfile(userData);
  }

  useEffect(() => {
    props.loadSplunk();
    props.loadUser();
    props.loadOrganization();
    document.title = 'Account Settings - Silent Push';
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (status === STATUS.LOADED) {
      setUserData(props.user);
    }
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoadingFinished = status === STATUS.LOADED || STATUS.IDLE;

  return isLoadingFinished ? (
    <>
      {show2FAModal && (
        <TwoFAModal
          onCancel={() => set2FAModal(false)}
          onFinish={() => set2FAModal(false)}
        />
      )}
      {showEditPasswordModal && (
        <EditPasswordModal
          onCancel={() => setShowEditPasswordModal(false)}
          onFinish={() => setShowEditPasswordModal(false)}
        />
      )}

      <Row justify="center" className={styles.account_settings}>
        <Col xs={24} sm={20} md={15} lg={10}>
          <Panel bgcolor={'#1C3138'}>
            <Row>
              <Col className={styles.profile_picture} xs={24}>
                {userData['photo'] ? (
                  <div
                    className={styles.avatar}
                    style={{
                      background: `no-repeat center/cover #ffffff url(${userData[
                        'photo'
                      ].replace('http://', 'https://')})`,
                    }}
                  ></div>
                ) : (
                  <div className={cx(styles.avatar, styles.empty)}>
                    <StopOutlined />
                  </div>
                )}

                <Title level={3}>
                  {userData['first_name']}&nbsp;{userData['last_name']}
                </Title>
              </Col>

              <Col className={styles.inputs} xs={24}>
                <Paragraph className={styles.paragaph}>Email</Paragraph>
                <Input
                  data-testid={'input1001'}
                  type="email"
                  placeholder={userData['email'] ?? 'Email'}
                  value={userData['email']}
                  onChange={(e) => handleChange(e, 'email')}
                ></Input>
              </Col>

              <Col className={styles.inputs} xs={24} xxl={11}>
                <Paragraph className={styles.paragaph}>Password</Paragraph>
                <Button onClick={openEditPasswordModal}>
                  <EditOutlined
                    title="edit password"
                    onClick={openEditPasswordModal}
                  />{' '}
                  Edit Password
                </Button>
              </Col>

              <Col xs={0} xxl={2}></Col>

              <Col className={styles.inputs} xs={24} xxl={11}>
                <Paragraph className={styles.paragaph}>
                  Two-Step Verification
                </Paragraph>
                {is2faEnabled ? (
                  <div className={styles.remove}>
                    <Input value="Authy" />
                    <CloseCircleOutlined onClick={props.remove2fa} />
                  </div>
                ) : (
                  <Button onClick={open2FAModal}>
                    Set Up Two Factor Authentication
                  </Button>
                )}
              </Col>

              <Col xs={24}>
                <Button
                  className={styles.saveAccount}
                  onClick={() => save()}
                  size="large"
                  type="primary"
                >
                  Save
                </Button>
              </Col>
            </Row>

            <VersionCheck parentComponentStatus={props.status} />
          </Panel>
        </Col>
      </Row>
    </>
  ) : (
    <EmptyLoadingState />
  );
}

export default AccountSettings;
